import { render } from "./eventAbout.vue?vue&type=template&id=8d176baa&scoped=true"
import script from "./eventAbout.vue?vue&type=script&lang=js"
export * from "./eventAbout.vue?vue&type=script&lang=js"

import "./eventAbout.vue?vue&type=style&index=0&id=8d176baa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d176baa"]])

export default __exports__